import * as React from "react";
import { Button,Toaster,Position, Card, Elevation, Overlay,Classes,Intent,H3 } from "@blueprintjs/core";

let Logo ="login.png";


export default class PanelChoixType extends React.Component <{}> {
  
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isTeacher: 'none',
      licence:''
    };
    this.handleChangeType = this.handleChangeType.bind(this);
    this.handleChangeLicence = this.handleChangeLicence.bind(this);
    this.handleSendCode = this.handleSendCode.bind(this);
    
  }
  
  componentDidMount () {
		const node = document.querySelectorAll('button');
    node.forEach(element => {
      const item=element.querySelectorAll('span')
      if(item[0]!= undefined)if(item[0].innerHTML=="Next")item[0].innerHTML="Etape suivante";
      if(item[0]!= undefined)if(item[0].innerHTML=="Back")item[0].innerHTML="Etape précédente";
    });    
  }

  handleChangeType(e) {
    //ev.preventDefault()
    //console.log(e);
    this.props.onChange(e.target);
    if(e.target.selectedIndex==0) this.setState({isTeacher:'none'});
    if(e.target.selectedIndex==1) this.setState({isTeacher:'none'});
    if(e.target.selectedIndex==2) this.setState({isTeacher:'block'});
  }
  handleChangeLicence(e){
    var stlicence=e.target.value;
    console.log(stlicence);
    if( stlicence.length<9)return;
    this.setState({licence:stlicence});
    this.handleSendCode(stlicence);
  }
  handleSendCode=function(code)
  {
  //toaster.show( {message:"login utilisateur: "+ userinfo.username+" - "+userpassword.password});
  var that = this;
  const toaster=Toaster.create({
    className: "my-toaster",
    position: Position.TOP_RIGHT,
  });
  var xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        var formData = new FormData();
        formData.append('code', code);
      
        xhr.open('GET','/api/public/lirelicence?licence='+code)
       
        xhr.setRequestHeader("Content-Type", "application/json");

        //send the form data
        xhr.send();//JSON.stringify(Object.fromEntries(formData)));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                          
             if(xhr.status==200) 
             { 
              toaster.show( {message:"LICENCE VALIDE"})
              var ev={tag:"licence_ok",value:that.state.licence};
              that.props.onChange(ev); 
             }
             if(xhr.status==404) {that.setState({licence:''});toaster.show( {message:"LICENCE INCONNUE"}); }
             if(xhr.status==500) {that.setState({licence:''});toaster.show( {message:"LICENCE INCONNUE"}); }
            // setUserPassword({})
            
            }
           
        }.bind(that)
  return //setisOpenLogin(false)
}.bind(this)

  render() {
    
    return (
      <div style={{padding:'10px'}}>
        <h3>Etudiant ou Enseignant ?</h3>
        <p>Pour plus d'informations, cliquez <a onClick={(ev)=>{ev.preventDefault();this.setState({isOpen:true})}} href="">En savoir plus</a>  </p>
        
        <Overlay isOpen={this.state.isOpen} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H3>Choix du type d'utilisateur</H3>
                        <p>
                            Ici choisissez si vous êtes un étudiant ou un enseignant.
                        </p>
                        <p>
                            Pour les enseignants, le code confidentiel que vous avez en votre possession sera à renseigner à cette étape.
                        </p>
                       
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();this.setState({isOpen:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                        </div>
                    </div>
                </Overlay>
        <div>
          <img height="250" src={Logo} /> 
        </div>
        <div style={{margin:'-20px 0 50px 0', padding:4}}>
        <select onChange={this.handleChangeType} >
            <option id='idop0' selected disabled hidden>Etudiant ou enseignant ?</option>
            <option id='idop1'>Je suis un étudiant</option>
            <option id='idop2'>Je suis un enseignant</option>
        </select>
        <p style={{margin:10,display:this.state.isTeacher}}>Entrez votre licence
        <input style={{marginLeft:5}} id='step1' type="text"  placeholder="Code licence" onChange={this.handleChangeLicence}/></p>
        </div>
      </div>
    );
  }
}
